import { error, success } from 'components/core/Notification';

export default {
  defaultFetchDataFailed: error('An error occurred during the data loading. Please try again.'),
  defaultSubmitDataFailed: error('Something went wrong. Please try again.'),
  exportEventFailed: error('Data export failed. Please try again.'),
  exportEventSuccess: success('Data has been exported successfully.'),
};
